export default {"src":"/_next/static/image/src/components/BillingInformationForm/discover.b5138d0bdd8800d52b54188bc24ac02e.svg","height":24,"width":34};